import { compose } from 'ramda';
import { branch, renderNothing, withProps } from 'recompose';
import { usePortletConfig, usePortletTranslations } from 'js/components/system/Portlet';
import { useFormatter } from 'js/hooks/useFormatter';
import { countDownModeTypes, COUNT_DOWN_TYPES } from '../../constants';
import withCountDown from './withCountDown';
import { minsToRaw } from './helpers';

export default compose(
    withProps(
        () => {
            const { countdownType, countdownBeforeEnd, countdownBeforeStart } = usePortletConfig();
            return {
                isStatic: countdownType === COUNT_DOWN_TYPES.static,
                countdownBeforeStart,
                countdownBeforeEnd
            };
        }
    ),
    branch(
        ({ isCompleted, isStatic }) => isCompleted && !isStatic,
        renderNothing
    ),
    withCountDown,
    branch(
        ({ isStatic }) => isStatic,
        compose(
            withProps(
                ({ startTime, endTime, modeType = 'ended' }) => {
                    const t = usePortletTranslations();
                    const formatter = useFormatter();

                    return {
                        label: t(`countDown.static.mode.${modeType}`),
                        value: modeType === countDownModeTypes.START
                            ? formatter.getDateTimeShort(startTime)
                            : formatter.getDateTimeShort(endTime)
                    };
                }
            )
        )
    ),
    branch(
        ({ modeType, isCompleted }) => modeType && !isCompleted,
        withProps(
            ({ modeType, timeTillEnd, countdownBeforeEnd, countdownBeforeStart }) => ({
                isHighlighted: modeType === countDownModeTypes.START
                    ? Boolean(countdownBeforeStart) && timeTillEnd.raw <= minsToRaw(countdownBeforeStart)
                    : Boolean(countdownBeforeEnd) && timeTillEnd.raw <= minsToRaw(countdownBeforeEnd)
            })
        )
    )
);
